'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.animationEnd = exports.transitionEnd = undefined;

var _Observable = require('rxjs/Observable');

require('rxjs/add/observable/fromEvent');

require('rxjs/add/observable/merge');

var transitionEndEventNames = ['webkitTransitionEnd', 'transitionend', 'msTransitionEnd', 'oTransitionEnd'];
var animationEndEventName = ['animationend', 'webkitAnimationEnd', 'MSAnimationEnd', 'oAnimationEnd'];

var mapEventsToObservable = function mapEventsToObservable(eventNames) {
    return function (el) {
        var events = eventNames.map(function (name) {
            return _Observable.Observable.fromEvent(el, name);
        });
        return _Observable.Observable.merge.apply(null, events);
    };
};

var transitionEnd = exports.transitionEnd = mapEventsToObservable(transitionEndEventNames);
var animationEnd = exports.animationEnd = mapEventsToObservable(animationEndEventName);


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/animation/events.js
// module id = ./resources/assets/js/src/animation/events.js
// module chunks = 0